class LeftPanelTableActions {
  roughSizeOfObject(object) {
    var objectList = [];
    var stack = [object];
    var bytes = 0;

    while (stack.length) {
      var value = stack.pop();

      if (typeof value === "boolean") {
        bytes += 4;
      } else if (typeof value === "string") {
        bytes += value.length * 2;
      } else if (typeof value === "number") {
        bytes += 8;
      } else if (typeof value === "object" && objectList.indexOf(value) === -1) {
        objectList.push(value);

        for (var i in value) {
          stack.push(value[i]);
        }
      }
    }
    return bytes;
  }

  clickLeftPanelUploadCandidates(user_input) {
    table_id = user_input.getAttribute("table_id");
    $(import_data_modal).modal("show");
  }
  async getGPTRequestButtonClicked(hot) {
    console.log("getGPTRequestButtonClicked clicked!!");
    document.getElementById("gpt_cost_compute_element_standard").innerText = "";
    let { selectedData, column_names_declared, selectedColumns } = new HotManipulation().getSelectedRowsFromHOT(hot);
    let gpt_table_prompts = JSON.parse(sessionStorage["gpt_table_prompts"]);
    let is_all_prompt_empty = gpt_table_prompts.every((item) => item.prompt == "");
    console.log(selectedData.length > 0 && !is_all_prompt_empty, selectedData.length, is_all_prompt_empty);
    // debugger;
    if (selectedData.length > 0 && !is_all_prompt_empty) {
      console.log("GPT Request Button Clicked");

      column_names_declared = JSON.parse(column_names_declared);
      let loader = '<div style="width:100%;text-align:center; padding:40px"><br>GPT Processes take time; We will notify you when its finished!</div>';
      document.getElementById("loader_gpt_process").innerHTML = loader;
      console.log("These are the rows selected::", selectedData);
      console.log({ gpt_table_prompts });
      let candidate_details = this.getSelectedCandidateDetailsFromHOT(hot);
      let candidate_ids = candidate_details.map((x) => x._id);
      if (candidate_ids[0] === null) {
        candidate_ids.shift(); // This will remove the first element if it's null
      }
      console.log({ candidate_ids });
      let requestBody = {
        visitor_fp: sessionStorage["visitor_fp"],
        job_obj: JSON.parse(sessionStorage["current_table"]),
        gpt_table_prompts: gpt_table_prompts,
        candidate_ids: candidate_ids,
        total_tokens: sessionStorage["total_tokens"],
      };
      try {
        setTimeout(() => {
          $(get_gpt_process_for_candidates).modal("hide");
        }, 3000);
        const response = await AjaxAPICall(eUrl.gptProcess, eMethod.post, requestBody);
        if (response.hasOwnProperty("status") && response.status == "ok") {
          // refreshJob()
          // $(get_gpt_process_for_candidates).modal("hide");
          // document.getElementById("loader_gpt_process").innerHTML = '';
          if (response?.data?.isMultiprocess) {
            var task_id = response?.data?.task_id;
            var intervalID = setInterval(async () => {
              try {
                var response = await AjaxAPICall(eUrl.dataPolling, eMethod.post, { task_id });
                if (response["status"] == "ok") {
                  if (response["data"].progress != "Task Finished" && response["data"].progress != "error") {
                    let msg = response["data"].process_name;
                    let task_id = response["data"].task_id;
                    let progress = response["data"].progress;
                    showToastMessage(msg, task_id, progress);
                  } else if (response["data"].progress == "Task Finished") {
                    clearInterval(intervalID);
                    let msg = response["data"].process_name;
                    let msg2 = response["data"].process_name + " has finished, refresh your page";
                    let task_id = response["data"].task_id;
                    let progress = response["data"].progress;
                    showToastMessage(msg, task_id, 100);
                    setTimeout(() => {
                      showToastMessage(msg2, task_id, progress);
                    }, 3000);
                  } else {
                    clearInterval(intervalID);
                    showToastMessage("something went wrong, on " + response["data"].process_name, "error");
                  }
                } else {
                  clearInterval(intervalID);
                  showToastMessage("something went wrong, " + response["data"].process_name, "error");
                }
              } catch (error) {
                console.log(error);
                clearInterval(intervalID);
                let toastMsg = document.getElementById(id);
                if (toastMsg) {
                }
              }
            }, 3000);
          }
        } else {
          if (response.hasOwnProperty("status") && response.status == "fail") {
            document.getElementById("loader_gpt_process").innerHTML = response?.message;
          }
          setTimeout(() => {
            $(get_gpt_process_for_candidates).modal("hide");
          }, 3000);
        }
      } catch (error) {
        console.log(error);
        $(get_gpt_process_for_candidates).modal("hide");
      }
      mixpanel.track("HOT GPT Request Button Clicked", {});
    } else {
      // $(get_gpt_process_for_candidates).modal("hide");
      let title = "Please Select Relevent Values ";
      let text = "either you have not select row or any operation";
      // generalMessagePopUpShow(title,text,()=>{
      document.getElementById("loader_gpt_process").innerHTML = "Please enter all details";
      // $(get_gpt_process_for_candidates).modal("show");
      // })
    }
  }
  getSelectedCandidateDetailsFromHOT(hot, columns = ["_id"]) {
    // columns should be hot_columns's data field value
    const selected = hot.getSelected() || [];
    console.log("These are the selected rows::", selected);
    let allCandidateData = [];
    if (selected.length > 0) {
      try {
        selected.forEach((arrayOfselection) => {
          let start = arrayOfselection[0];
          let end = arrayOfselection[2];
          if (start > end) {
            [start, end] = [end, start];
          }
          for (let i = start; i <= end; i++) {
            let obj = {};
            columns.forEach((column) => {
              let value = hot.getDataAtRowProp(i, column);
              if (value !== null && value !== undefined) {
                if (typeof value === "string") {
                  value = value.replace(/[\t\n]/g, "");
                }
                if (value.trim() !== "") {
                  obj[column] = value;
                }
              } else {
                obj[column] = null;
              }
            });
            allCandidateData.push(obj);
          }
        });
      } catch (error) {
        console.log("error in get Candidate Details From HOT");
        console.log({ error });
      }
    }
    return allCandidateData;
  }

  async customPromptBaseFilterSubmitButton(hot) {
    console.log("custom_prompt_base_filter_submit_button called for hot");
    document.getElementById("gpt_cost_compute_element").innerText = "";
    sessionStorage["gpt_table_prompts"] = JSON.stringify(gpt_prompts);
    console.log("prompt base filter Button Clicked");
    let selectDropDownColumn = new Components().getAllSelectedFields("selected_option_chips");
    console.log("This is selectDropDownColumn::", selectDropDownColumn);
    let output_option = $("#prompt_enum_textarea").textext()[0].tags()["_formData"];
    let question_prompt = document.getElementById("input_prompt_base_filter_text").value;
    // let candidate_ids = this.getSelectedCandidate(hot)
    let columns_name = ["_id"];
    // gpt_prompts.forEach(x=>{
    //     columns_name.push(x.data)
    // })
    let candidate_details = this.getSelectedCandidateDetailsFromHOT(hot, columns_name);
    console.log("These are the candidate details::", candidate_details);
    let candidate_ids = candidate_details.filter((detail) => detail != null && detail._id != null).map((detail) => detail._id);
    console.log(candidate_ids);
    console.log("candidate_ids");
    if (selectDropDownColumn.length <= 0) {
      document.getElementById("validation_message").innerText = "Please Select columns from Dropdown";
      document.getElementById("validation_message").style.display = "block";
      return;
    }
    if (output_option.length <= 0) {
      document.getElementById("validation_message").innerText = "Please provide output values";
      document.getElementById("validation_message").style.display = "block";
      // return
    }
    if (question_prompt.trim() == "") {
      document.getElementById("validation_message").innerText = "Please provide prompt";
      document.getElementById("validation_message").style.display = "block";
      return;
    }
    if (candidate_ids.length <= 0) {
      document.getElementById("validation_message").innerText = "Please select rows";
      document.getElementById("validation_message").style.display = "block";
      return;
    }
    let columns = JSON.parse(sessionStorage["gpt_table_prompts"]);
    selectDropDownColumn = selectDropDownColumn.map((x) => {
      let db_column = "";
      columns.forEach((column) => {
        if (column.field.trim().toLowerCase() === x.trim().toLowerCase()) {
          db_column = column.data;
        }
      });
      return db_column;
    });

    let gpt_table_prompts = [];
    if (selectDropDownColumn.includes("fitment")) {
      let dropDownColumn = selectDropDownColumn.filter((x) => x != "fitment");
      gpt_table_prompts = [
        {
          prompt: "fitment",
          output_option: output_option,
          selectDropDownColumn: dropDownColumn,
          question_prompt: question_prompt,
        },
      ];
    } else if (selectDropDownColumn.includes("raw_cv")) {
      gpt_table_prompts = [
        {
          prompt: "raw_cv",
          output_option: output_option,
          selectDropDownColumn: ["raw_cv"],
          question_prompt: question_prompt,
        },
      ];
    } else {
      gpt_table_prompts = [
        {
          prompt: "custom_prompt",
          output_option: output_option,
          selectDropDownColumn: selectDropDownColumn,
          question_prompt: question_prompt,
        },
      ];
    }

    let requestBody = {
      visitor_fp: sessionStorage["visitor_fp"],
      job_obj: JSON.parse(sessionStorage["current_table"]),
      gpt_table_prompts: gpt_table_prompts,
      candidate_ids: candidate_ids,
      total_tokens: sessionStorage["total_tokens"],
    };
    let loader = '<div style="width:100%;text-align:center; padding:40px"><br>GPT Processes take time; We will notify you when its finished!</div>';

    document.getElementById("loader_prompt_base_filter_process").innerHTML = loader;
    document.getElementById("validation_message").style.display = "none";
    try {
      setTimeout(() => {
        $(promptBaseFilterModal).modal("hide");
      }, 3000);
      const response = await AjaxAPICall(eUrl.gptProcess, eMethod.post, requestBody);
      if (response.hasOwnProperty("status") && response.status == "ok") {
        // refreshJob()
        // document.getElementById("loader_gpt_process").innerHTML = '';
        // $(promptBaseFilterModal).modal("hide");
        if (response?.data?.isMultiprocess) {
          var task_id = response?.data?.task_id;
          var intervalID = setInterval(async () => {
            try {
              var response = await AjaxAPICall(eUrl.dataPolling, eMethod.post, { task_id });
              if (response["status"] == "ok") {
                if (response["data"].progress != "Task Finished" && response["data"].progress != "error") {
                  clearInterval(intervalID);
                  let msg = response["data"].process_name;
                  let task_id = response["data"].task_id;
                  let progress = response["data"].progress;
                  showToastMessage(msg, task_id, progress);
                } else if (response["data"].progress == "Task Finished") {
                  clearInterval(intervalID);
                  let msg = response["data"].process_name;
                  let msg2 = response["data"].process_name + " has finished, refresh your page";
                  let task_id = response["data"].task_id;
                  let progress = response["data"].progress;
                  showToastMessage(msg, task_id, 100);
                  setTimeout(() => {
                    showToastMessage(msg2, task_id, progress);
                  }, 3000);
                } else {
                  clearInterval(intervalID);
                  showToastMessage("something went wrong, on " + response["data"].process_name, "error");
                }
              } else {
                clearInterval(intervalID);
                showToastMessage("something went wrong, " + response["data"].process_name, "error");
              }
            } catch (error) {
              console.log(error);
              clearInterval(intervalID);
              let toastMsg = document.getElementById(id);
              if (toastMsg) {
              }
            }
          }, 3000);
        }
      } else {
        if (response.hasOwnProperty("status") && response.status == "fail") {
          document.getElementById("loader_gpt_process").innerHTML = response?.message;
        }
        setTimeout(() => {
          $(promptBaseFilterModal).modal("hide");
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      $(promptBaseFilterModal).modal("hide");
    }

    mixpanel.track("HOT custom user prompt base filter Button Clicked", {});
  }
  addChipOnUserInput() {
    var oldChips = document.getElementById("output_enums_chip");
    let text = document.getElementById("output_enums_text");
    let newVal = Date.now();
    new components().addChipInUIbyId("output_enums_chip", text);
    new components().clear_input_value_by_id("output_enums_text");
    let newChips = document.getElementById("output_enums_chip");
    let addchipText = document.getElementById("output_enums_text");

    addchipText.value = newChips + "\n";

    // var textarea = document.getElementById('output_enums_text');
    // textarea.innerHTML += chips + '\n';
    // let text = new components().get_input_value_by_id('output_enums_text');
    // new components().addChipInTextAreabyId('output_enums_text',text)
  }
  clickLeftPanelImportActiveCandidates() {
    console.log("Clicked left panel import active candidates");
    $.ajax({
      url: "/celery_test",
      type: "POST",
      data: { visitor_fp: sessionStorage["visitor_fp"] },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
      },
    }).done(function (data) {
      console.log("AJAX to hit celery/test ");
      console.log("This is the AJAX response ", data);
      console.log("token got ehre");
      console.log(data);
      console.log(data.status);
    });
  }

  addCustomQueryInModal() {
    document.getElementById("table_custom_gpt_column").style.display = "";
  }

  callChangeForButtonClickedInGPTProcessTable(user_input) {
    console.log("THis got clicked::", user_input);
  }

  clickLeftPanelGetGPTProcess() {
    console.log("Left panel click ");
    sessionStorage["gpt_table_prompts"] = JSON.stringify(gpt_prompts);
    $(get_gpt_process_for_candidates).modal("show");
    document.getElementById("loader_gpt_process").innerHTML = "";
    document.getElementById("gpt_cost_compute_element_standard").innerText = "";
    // Data array
    var data_arr = [
      {
        field: "Name:",
        "Select Column": [
          { column: "Gender", prompt: "gender" },
          { column: "Ethnicity", prompt: "ethnicity" },
          { column: "Nationality", prompt: "nationality" },
        ],
      },
      {
        field: "Education:",
        "Select Column": [
          { column: "Education Score", prompt: "education_score" },
          { column: "Education Type", prompt: "education_type" },
          { column: "UG Specialisation", prompt: "ug_specialisation" },
          { column: "PG Specialisation", prompt: "pg_specialisation" },
        ],
      },
      {
        field: "Job Titles:",
        "Select Column": [
          { column: "Seniority", prompt: "seniority" },
          { column: "Function", prompt: "function" },
          { column: "Sub-Function", prompt: "sub_function" },
        ],
      },
      {
        field: "Profile:",
        "Select Column": [
          { column: "Number of Job Changes", prompt: "number_of_job_changes" },
          { column: "Number of Promotions", prompt: "number_of_promotions" },
          { column: "Last modified", prompt: "last_modified" },
          { column: "Propensity to switch", prompt: "propensity_to_switch" },
          { column: "Propensity to relocate", prompt: "propensity_to_relocate" },
          { column: "Estimated Salary", prompt: "estimated_salary" },
          { column: "Has any of these people X", prompt: "has_any_of_these_people_x" },
        ],
      },
      {
        field: "Location:",
        "Select Column": [
          { column: "Distance from Job", prompt: "distance_from_job" },
          { column: "Population of Town", prompt: "population_of_town" },
        ],
      },
      {
        field: "Company Name:",
        "Select Column": [
          { column: "Company Promoter Info", prompt: "company_promoter" },
          { column: "Company Scores", prompt: "company_scores" },
          { column: "Company Size", prompt: "company_size" },
          { column: "isLayingOff", prompt: "islayingoff" },
          { column: "Industry", prompt: "industry" },
          { column: "Link to Org Chart", prompt: "link_org_chart" },
          { column: "Company Type", prompt: "company_type" },
        ],
      },
    ];

    // Function to populate the table
    function populateMappingTable() {
      var tbody = document.getElementById("mapping_table_body");
      // tbody.id = "gpt_table_prompts_element"
      tbody.innerHTML = "";
      data_arr.forEach(function (data) {
        var tr = document.createElement("tr");

        // Create the label cell
        var labelTd = document.createElement("td");
        labelTd.innerHTML = '<label style="font-size:13px" for="' + data.field.replace(":", "") + '">' + data.field + "</label>";
        tr.appendChild(labelTd);

        // Create the dropdown cell
        var dropdownTd = document.createElement("td");
        dropdownTd.style.padding = "5px";
        dropdownTd.innerHTML =
          '<div style="display:table-cell"><div id = "gpt_table_prompts_element" class="dropdown"><button onclick = "new LeftPanelTableActions().callChangeForButtonClickedInGPTProcessTable(this)"  id="' +
          data.field.replace(":", "") +
          '_btn" class="btn dropdown-toggle" type="button" style="font-size:10pt; width:200px; background-color:white; color:black; border:1px solid rgb(210,210,210)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><div style="display:inline-block;text-align:left; width:130px;">Select Column</div></button><div class="dropdown-menu" style="font-size: 10pt; max-height: 400px; overflow-y: auto;"></div></div></div>';
        // Populate the dropdown menu
        var dropdownMenu = dropdownTd.querySelector(".dropdown-menu");
        data["Select Column"].forEach(function (option, index) {
          var dropdownItem = document.createElement("a");
          dropdownItem.className = "dropdown-item";
          dropdownItem.href = "javascript:";
          dropdownItem.textContent = option.column;
          dropdownItem.setAttribute("data-field", data.field.replace(":", ""));
          dropdownItem.setAttribute("data-prompt", option.prompt);
          dropdownItem.onclick = function () {
            selectColumn(this);
          };
          dropdownMenu.appendChild(dropdownItem);
        });

        tr.appendChild(dropdownTd);

        tbody.appendChild(tr);
      });

      let dropdownCustomGPT = document.getElementById("custom_gpt_column_dropdown");
      if (dropdownCustomGPT) {
        dropdownCustomGPT.innerHTML =
          '<div style="display:table-cell"><div id = "gpt_table_prompts_element" class="dropdown"><button id="custom_gpt_process_btn" class="btn dropdown-toggle" type="button" style="font-size:10pt; width:200px; background-color:white; color:black; border:1px solid rgb(210,210,210)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><div style="display:inline-block;text-align:left; width:130px;">Select Column</div></button><div class="dropdown-menu" style="font-size: 10pt; max-height: 400px; overflow-y: auto;"></div></div></div>';
        dropdownCustomGPT.style.padding = "5px";
        data_arr.forEach(function (data) {
          let dropdownMenu = dropdownCustomGPT.querySelector(".dropdown-menu");
          let columnName = data.field.replace(":", "");
          let dropdownItem = document.createElement("a");
          dropdownItem.className = "dropdown-item";
          dropdownItem.href = "javascript:";
          dropdownItem.textContent = columnName;
          dropdownItem.setAttribute("data-field", columnName);
          dropdownItem.onclick = function () {
            selectColumnForCustomPromptDropDown(this);
          };
          dropdownMenu.appendChild(dropdownItem);
        });
      }

      // let inputPromptText = document.getElementById("custom_gpt_column_input_text");
      // inputPromptText.innerHTML =`<div style="display:table-cell"><input id="custom_gpt_process_input" value="" class="search-bar-front" autocomplete="custom-gpt-process"  placeholder="🔍 Search any company's org chart" style=" width:140%; border-color:rgb(232,232,232); placeholder-color:rgb(232,232,232);"></div>`
    }

    // Function to simulate the selectColumn function
    function selectColumn(selectedItem) {
      let btn = selectedItem.parentElement.parentElement.parentElement.querySelector("button");
      btn.setAttribute("data-selected", selectedItem.textContent);
      btn.querySelector("div").textContent = selectedItem.textContent;
      let gpt_table_prompts = JSON.parse(sessionStorage["gpt_table_prompts"]);
      let dataField = selectedItem.getAttribute("data-field");
      let dataPrompt = selectedItem.getAttribute("data-prompt");
      console.log(dataField, dataPrompt);
      gpt_table_prompts = gpt_table_prompts.map((item) => (item.type == "defined" && item.field == dataField ? { ...item, prompt: dataPrompt } : item));
      sessionStorage["gpt_table_prompts"] = JSON.stringify(gpt_table_prompts);
      new UtilityFunctions().get_gpt_cost_by_token("", true);
    }

    function selectColumnForCustomPromptDropDown(selectedItem) {
      let btn = selectedItem.parentElement.parentElement.parentElement.querySelector("button");
      btn.setAttribute("data-selected", selectedItem.textContent);
      btn.querySelector("div").textContent = selectedItem.textContent;
      let columnName = selectedItem.getAttribute("data-field");
      console.log(columnName);
      gpt_table_prompts = JSON.parse(sessionStorage["gpt_table_prompts"]);
      gpt_table_prompts = gpt_table_prompts.map((item) => (item.type == "custom" ? { ...item, field: columnName } : item));
      sessionStorage["gpt_table_prompts"] = JSON.stringify(gpt_table_prompts);
    }

    // // Function to handle the submit button click
    // function onClickButtonSubmitCSVData() {
    // 	// Add your logic to handle the submit action here
    // 	// This function will be called when the "Import Data" button is clicked
    // }

    // Call the function to populate the table
    populateMappingTable();
  }

  clickConfirmLeftPanelDeduplicateRecords() {
    var changes_made_obj = {};
    changes_made_obj["update_type"] = "deduplicate_records";
    changes_made_obj["table_id"] = JSON.parse(sessionStorage["current_table"])["table_id"];
    console.log("This is the changes made obj::", changes_made_obj);
    $.ajax({
      url: "/update_hands_on_table",
      type: "POST",
      data: {
        user_id: localStorage["user_id"],
        params: params_obj,
        visitor_fp: sessionStorage["visitor_fp"],
        changes_made_obj: JSON.stringify(changes_made_obj),
      },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
      },
    }).done(function (data) {
      console.log("data received::", data);
      if (data?.status == "fail") {
        $(".modal:visible").modal("hide");
        document.getElementById("general_message_title").innerText = data?.message || "Something went wrong!!!";
        document.getElementById("general_message_text").innerText = "Something went wrong!, Please try again after some time or contact us";
        $(general_message_modal).modal("show");
      }
    });
    $(confirm_deduplicate).modal("hide");
  }
  clickLeftPanelDeduplicateRecords() {
    $(confirm_deduplicate).modal("show");
  }

  getRowsToSelectFromSelectedRows(selected_rows) {
    let rowsToSelect = [];

    selected_rows.forEach((range) => {
      console.log("range from::", range.from, "range to ", range.to);

      if (range.from.row < range.to.row) {
        for (let i = range.from.row; i <= range.to.row; i++) {
          if (i != null) {
            rowsToSelect.push(i);
          }
        }
      } else {
        for (let i = range.to.row; i <= range.from.row; i++) {
          if (i != null) {
            rowsToSelect.push(i);
          }
        }
      }
    });
    return rowsToSelect;
  }

  getSelectedRowsFromHotForStandardization() {
    // This function is the same as getSelectedRowsFromHOT but also does some cleaning and returns the ids
    let hot = hotInstance.getHotInstance();
    let selected_rows = hot.getSelectedRange();
    console.log("This is selected rows:::", selected_rows);
    console.log("This is selected rows:::", selected_rows);

    if (!selected_rows) {
      console.log("selected_rows.length::", selected_rows?.length);
      selected_rows = hot.selectAll();
      selected_rows = hot.getSelectedRange();
      console.log("Changing selected rows and it is ::", selected_rows);
    }
    console.log("Final selected rows and it is ::", selected_rows);
    console.log("These are number of selected rows::", selected_rows.length);

    // Collect all the rows to remove from each range
    let rowsToSelect = this.getRowsToSelectFromSelectedRows(selected_rows);
    if (rowsToSelect.length == 1) {
      console.log("selected_rows.length::", selected_rows?.length);
      let selected_rows = hot.selectAll();
      selected_rows = hot.getSelectedRange();
      console.log("Changing selected rows and it is ::", selected_rows);
      rowsToSelect = this.getRowsToSelectFromSelectedRows(selected_rows);
    }
    let candidate_ids = [];
    console.log("Rows to remove and call a function:::", rowsToSelect);
    try {
      candidate_ids = rowsToSelect.map((x) => hot.getDataAtRowProp(x, "_id")).filter((id) => id !== null);
    } catch {}
    console.log("These are the selected candidate ids::", candidate_ids);
    return candidate_ids;
  }

  clickConfirmLeftPanelStandardizeRecords() {
    var changes_made_obj = {};
    changes_made_obj["update_type"] = "standardize_records";
    let candidate_ids = this.getSelectedRowsFromHotForStandardization();
    console.log("The number of rows selected is ::%s", candidate_ids.length);
    changes_made_obj["table_id"] = JSON.parse(sessionStorage["current_table"])["table_id"];
    changes_made_obj["rows_to_standardize"] = candidate_ids;
    console.log("This is the changes made obj::", changes_made_obj);
    $.ajax({
      url: "/update_hands_on_table",
      type: "POST",
      data: {
        user_id: localStorage["user_id"],
        params: params_obj,
        visitor_fp: sessionStorage["visitor_fp"],
        changes_made_obj: JSON.stringify(changes_made_obj),
      },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
      },
    }).done(function (data) {
      console.log("data received::", data);
      if (data?.status == "fail") {
        $(".modal:visible").modal("hide");
        document.getElementById("general_message_title").innerText = data?.message || "Something went wrong!!!";
        document.getElementById("general_message_text").innerText = "Something went wrong!, Please try again after some time or contact us";
        $(general_message_modal).modal("show");
      }
    });
    $(confirm_standardize_job_modal).modal("hide");
  }

  clickLeftPanelStandardizeRecords() {
    $(confirm_standardize_job_modal).modal("show");
  }

  setWidthofTextArea() {
    console.log("Setting width of text area");
    var referredEmails = document.getElementById("prompt_enum_textarea");
    if (referredEmails && referredEmails.parentElement.classList.contains("text-wrap")) {
      referredEmails.parentElement.style.width = "100%";
      referredEmails.parentElement.style.height = "30px";
      referredEmails.parentElement.style.fontSize = "12px";
    }
    document.getElementById("prompt_enum_textarea").style.width = "95%";
    document.getElementById("prompt_enum_textarea").style.fontSize = "12px";
    document.getElementById("prompt_enum_textarea").style.height = "auto";
    document.getElementById("prompt_enum_textarea").style.overflow = "auto";
  }

  clickLeftPanelGetPromptBaseFilter() {
    console.log("Clicked Left Panel clickLeftPanelGetPromptBaseFilter called ");
    $(promptBaseFilterModal).modal("show");
    var parentElement = document.getElementById("parent_tags_div");
    try {
      while (parentElement != null && parentElement != undefined && parentElement.firstChild) {
        parentElement.parentNode.insertBefore(parentElement.firstChild, parentElement);
      }
      parentElement.parentNode.removeChild(parentElement);
    } catch {}

    if (!$("#prompt_enum_textarea").data("textext-initialized")) {
      $("#prompt_enum_textarea").textext({
        plugins: "tags, prompt",
        prompt: "add tag",
      });
      $("#prompt_enum_textarea").data("textext-initialized", true);
    }

    console.log("Adding event listeners");
    this.setWidthofTextArea();

    // Attach an event listener to the modal close event
    $(promptBaseFilterModal).on("hidden.bs.modal", function () {
      // Get the TextExt instance
      var textext = $("#prompt_enum_textarea").textext()[0];
      $("#prompt_enum_textarea").val("");
      // prompt_enum_textarea
      // Clear the content and tags
      if (textext) {
        $(".text-tags a.text-remove").trigger("click");
      }
      document.getElementById("gpt_cost_compute_element").innerText = "";
      document.getElementById("validation_message").innerText = "";
      document.getElementById("loader_prompt_base_filter_process").innerText = "";
    });
  }

  cancelPromptBaseFilter() {
    document.getElementById("validation_message").innerText = "";
    document.getElementById("validation_message").style.display = "none";
    document.getElementById("loader_prompt_base_filter_process").innerHTML = "";
    $(promptBaseFilterModal).modal("hide");
  }

  clickLeftPanelGetPhoneNumbers() {
    $(get_phone_numbers_for_candidates_hot).modal("show");
  }
  clickLeftPanelGetEmailAddresses() {
    $(get_email_addresses_for_candidates_hot).modal("show");
  }

  clickLeftPanelSendEmail() {
    $(send_email_to_candidates_modal).modal("show");
  }
  cancelAddtoSublist() {
    $(create_add_to_sublist_modal).modal("hide");
  }
  cancelRunGPTProcess() {
    $(get_gpt_process_for_candidates).modal("hide");
  }
  cancelGetPhoneNumbersProcess() {
    $(get_phone_numbers_for_candidates_hot).modal("hide");
  }

  cancelGetEmailAddressesProcess() {
    $(get_email_addresses_for_candidates_hot).modal("hide");
  }

  clickLeftPanelImportPassiveCandidates() {
    console.log("This is clickLeftPanelImportPassiveCandidates");
    // $(fetch_people_list_across_companies_results).modal('show')
    this.importDataModal();
  }

  importDataModal() {
    console.log("This is going to import data modal:: importDataModal");

    $(import_data_modal).modal("show");
    $("#filename").off("change");
    $("#filename").change(function (e) {
      e.preventDefault();
      console.log("this is the filename import function being called!");
      var ext = $("input#filename").val().split(".").pop().toLowerCase();
      // debugger;
      let file_name_uploaded = $("input#filename").val().split("\\")[2];
      document.getElementById("file_name_uploaded").innerText = file_name_uploaded;
      var file = e.target.files[0];
      console.log("Got file::", file);
      console.log("Got ext::", ext);

      if (e.target.files != undefined) {
        console.log("E.files is not undefined");
        var reader = new FileReader();
        reader.onload = function (event) {
          console.log("Starting reader load");
          var fileContent = event.target.result;

          // Determine the file type (CSV or Excel) based on the file name or MIME type
          if (file.name.endsWith(".csv") || file.type === "text/csv") {
            // Handle CSV file
            var csvData = new UtilityFunctions().parseCSV(fileContent);
            new uploadExcelCSVCandidates().saveDataToSessionStorage("csv_data", csvData);
          } else if (file.name.endsWith(".xlsx") || file.name.endsWith(".xls") || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel") {
            // Handle Excel file
            var excelData = new UtilityFunctions().parseExcel(fileContent);
            new uploadExcelCSVCandidates().saveDataToSessionStorage("excel_data", excelData);
          } else {
            alert("Unsupported file format. Please upload a CSV or Excel file.");
          }
        };
        reader.readAsBinaryString(e.target.files.item(0));
        $("#filename").val("");
      }
    });
  }

  importResumesModal() {
    console.log("This is going to import data modal:: importDataModal");

    $(import_resumes_modal).modal("show");

    document.getElementById("fileUploadInput").addEventListener("change", updateFileList);

    function updateFileList() {
      const files = document.getElementById("fileUploadInput").files;
      const fileListContainer = document.getElementById("fileList");
      fileListContainer.innerHTML = "";

      if (files.length > 0) {
        let displayText = "";
        const maxDisplay = 3;

        Array.from(files).forEach((file, index) => {
          if (index < maxDisplay) {
            const fileName = file.name.length > 25 ? file.name.substring(0, 22) + "..." : file.name;
            displayText += fileName + (index < maxDisplay - 1 && index < files.length - 1 ? ", " : "");
          }
        });

        if (files.length > maxDisplay) {
          displayText += ` and ${files.length - maxDisplay} other${files.length - maxDisplay > 1 ? "s" : ""}`;
        }

        fileListContainer.textContent = displayText;
      } else {
        fileListContainer.textContent = "No files selected.";
      }
    }

    document.getElementById("dragDropArea").addEventListener("click", function () {
      document.getElementById("fileUploadInput").click();
    });

    document.getElementById("dragDropArea").addEventListener("dragover", function (event) {
      event.preventDefault();
      event.stopPropagation();
      this.classList.add("drag-over");
    });

    document.getElementById("dragDropArea").addEventListener("dragleave", function (event) {
      event.preventDefault();
      event.stopPropagation();
      this.classList.remove("drag-over");
    });

    document.getElementById("dragDropArea").addEventListener("drop", function (event) {
      event.preventDefault();
      event.stopPropagation();
      this.classList.remove("drag-over");
      document.getElementById("fileUploadInput").files = event.dataTransfer.files;
      updateFileList();
    });
  }

  downloadAllResdexResumes() {
    console.log("Download all reasumes clicked");
    var user_id = localStorage["user_id"];
    console.log("This is the base url");
    var table_id = JSON.parse(sessionStorage["current_table"])["table_id"];
    console.log("This is the base url in resdex::", base_url);
    var url = base_url + "/download_resumes/" + user_id + "/" + table_id;
    // var url = 'http://localhost:5050/'+'download_resumes/'+user_id+'/'+table_id
    const a = document.createElement("a");
    a.href = url;
    // debugger;
    // a.download = url.split('http://localhost:5050')[1]
    a.download = JSON.parse(sessionStorage["current_table"])["table_name"] + ".zip";
    // debugger;
    document.body.appendChild(a);
    console.log("Final usl  = ", url);
    a.click();
    document.body.removeChild(a);
  }

  uploadResumesFiles() {
    console.log("This is the upload resumes files");

    const files = document.getElementById("fileUploadInput").files;
    const batchSize = 5;
    let currentBatch = 0;

    var json_data = {
      user_id: localStorage["user_id"],
      job_id: JSON.parse(sessionStorage["current_table"])["table_id"],
      job_name: JSON.parse(sessionStorage["current_table"])["table_name"],
    };

    function uploadBatch(batchFiles, batchNumber) {
      const formData = new FormData();
      batchFiles.forEach((file) => formData.append("files[]", file));

      // Append JSON data to FormData
      for (const key in json_data) {
        if (json_data.hasOwnProperty(key)) {
          formData.append(key, json_data[key]);
        }
      }

      fetch("/upload_resumes", {
        // Replace '/upload' with your server endpoint
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(`Batch ${batchNumber} uploaded successfully`, data);
          currentBatch++;
          if (currentBatch * batchSize < files.length) {
            // Upload next batch
            nextBatch();
          }
        })
        .catch((error) => {
          if (error.message.includes("signed out")) {
            new PageContents().tokenExpireAction();
          }
          console.log(`Error in uploading batch ${batchNumber}`, error);
        });
    }

    // Function to prepare and upload the next batch
    function nextBatch() {
      const start = currentBatch * batchSize;
      const end = Math.min(start + batchSize, files.length);
      const batchFiles = Array.from(files).slice(start, end);
      uploadBatch(batchFiles, currentBatch + 1);
    }

    // Start uploading the first batch
    nextBatch();
  }
}

class ListPageElements {
  createAllJobsListings() {
    var params_obj = updateParamsObj();
    $.ajax({
      url: "/get_all_jobs",
      type: "POST",
      data: {
        user_id: localStorage["user_id"],
        params: params_obj,
        visitor_fp: sessionStorage["visitor_fp"],
      },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
        if (error_status == 429) {
          console.log("Too Many Requests");
          document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          // Not trying to reset session storage if there's an error
          // new ProcessNodesStates().resetSessionStorageforDropdowns()
        }
        if (error_status == 500) {
          console.log("There has been an error in the autocomplete query");
          new Pages().loginPage();
        }
      },
    }).done(function (data) {
      console.log("AJAX to hit ", data);
      console.log("This is the AJAX response ", data);
      // console.log(data);
      // data = JSON.parse(data)
      // debugger;
      if (typeof data == "object" && data["all_jobs_arr"].length > 0) {
        var all_jobs = data["all_jobs_arr"];
        console.log("Setting all  sessionStorage jobs here:::", all_jobs);
        sessionStorage["all_jobs"] = JSON.stringify(all_jobs);
        sessionStorage["all_jobs_details"] = JSON.stringify(data["jobs"]);
        var all_jobs_rows = "";
        while (all_jobs.length) {
          var single_jobs_row = all_jobs.splice(0, 4);
          var single_jobs_row_html = "";
          for (var single_job in single_jobs_row) {
            // debugger;
            var single_jobs_row_html =
              single_jobs_row_html +
              document
                .getElementById("job_card_element")
                .innerHTML.replaceAll("{job_id}", single_jobs_row[single_job]["job_id"])
                .replaceAll("{job_name}", new UtilityFunctions().truncateString(single_jobs_row[single_job]["job_name"], 20))
                .replaceAll("{start_date}", new UtilityFunctions().dateTimetoHumanString(single_jobs_row[single_job]["start_date"]));
          }
          all_jobs_rows = all_jobs_rows + '<div style="display:table; width:100%">' + single_jobs_row_html + "</div><br><br>";
        }
        var all_jobs_listing = '<div style="text-align:center; width:90%;margin: auto;left:0;right: 0; margin-top:3%">' + all_jobs_rows + "</div>";
        document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = all_jobs_listing;
        document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = all_jobs_listing;
      } else {
        document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("empty_screen_element").innerHTML.replace("{empty_screen_element_message}", "Please start by creating a new job");
        document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("empty_screen_element").innerHTML.replace("{empty_screen_element_message}", "Please start by creating a new job");
      }
    });
  }
  setUpListsTable() {
    var table_top = '<table id="list-people">';
    // var table_headers = '<thead><tr><th>full_name</th><th>job_company_id</th><th>job_company_name</th><th>job_company_website</th><th>location_name</th><th>industry</th><th>job_title</th><th>linkedin_url</th><th>facebook_url</th><th>twitter_url</th><th>phone_numbers</th><th>emails</th></tr></thead>'
    var table_headers = "<thead><tr><th>Index</th><th>Data Source</th><th>Costs</th><th>Delivery Time</th><th>Recency</th><th>Coverage</th></tr></thead>";
    var table_body =
      "<tbody><tr><td>1</td><td>Search Engine Results</td><td>1 credit/ person</td><td>10-15 mins</td><td>As real time as Linkedin</td><td>~90% of Linkedin Database</td></tr><tr><td>2</td><td>Arxena Partner Data API - I</td><td>4 credits/ person</td><td>1-2 mins</td><td>As real time as Linkedin</td><td>~90% of Linkedin Database</td></tr><tr><td>3</td><td>Arxena Partner Data API - II</td><td>.5 credits/ person</td><td>1-2 mins</td><td>1-2 years old</td><td>~90% of Linkedin Database</td></tr><tr><td>4</td><td>Your own Database </td><td>.5 credits/ person</td><td>1-2 mins</td><td>Real Time</td><td>100% of Database</td></tr><tr><td>5</td><td>Your account in Linkedin, etc.</td><td>.5 credits/ person</td><td>1-2 mins</td><td>Real Time</td><td>100% of Database</td></tr></tbody>";

    var table_footer = "<tfoot><tr><th>Index</th><th>Data Source</th><th>Costs</th><th>Delivery Time</th><th>Recency</th><th>Coverage</th></tr></tfoot>";
    var table_footer2 = "<tfoot><tr><th>Index</th><th>Data Source</th><th>Costs</th><th>Delivery Time</th><th>Recency</th><th>Coverage</th></tr></tfoot>";
    var table_bottom = "</table>";

    var table_total = table_top + table_headers + table_footer + table_footer2 + table_body + table_bottom;
    document.getElementById("list_costs_table").innerHTML = table_total;

    // Adding this because when new table is created, this modal doesn't stop showing. Damn wierd.
    try {
      console.log("Trying to close the damn modal");
      $(waiting_results_raw_string).modal("hide");
    } catch (error) {
      console.log("Error:", error);
    }

    $("#list-people tfoot th").each(function () {
      var title = $(this).text();
      // For selected ones only
      console.log("This is the classname ::", $(this)[0]);
      if ($(this)[0].className === "data source") {
        $(this).html('<input type="text" placeholder="Search ' + title + '" />');
      }
      // For all
      // $(this).html('<input type="text" placeholder="Search ' + title + '" />');
    });

    $("#list-people tfoot th").each(function () {
      var title = $(this).text();
      $(this).html('<input type="text" placeholder="Search ' + title + '" />');
    });

    var table = $("#list-people").DataTable({
      dom: "Bfrtip",
      paging: false,
      buttons: [
        // {extend:'excel', title:'People Data Export'}
      ],
      initComplete: function () {
        this.api()
          .columns()
          .every(function () {
            var column = this;
            var select = $('<select><option value=""></option></select>')
              .appendTo($(column.footer()).empty())
              .on("change", function () {
                var val = $.fn.dataTable.util.escapeRegex($(this).val());

                column.search(val ? "^" + val + "$" : "", true, false).draw();
              });

            column
              .data()
              .unique()
              .sort()
              .each(function (d, j) {
                select.append('<option value="' + d + '">' + d + "</option>");
              });
            var that = this;

            $("input", this.footer()).on("keyup change clear", function () {
              if (that.search() !== this.value) {
                that.search(this.value).draw();
              }
            });
          });
      },
    });

    // table.button(0).trigger();
    var all_tfoot = document.querySelectorAll("tfoot");
    for (var i = 0; i < all_tfoot.length; i++) {
      // debugger;
      all_tfoot[i].style.display = "table-header-group";
    }
    $("input[name=filterReportDD]").click(function () {
      if ($(this).is(":checked")) {
        groupNameFilterApplied.push($(this).val());
      }

      $("#reportDataTable").DataTable().column(2).search(groupNameFilterApplied.join("|"), true, false, true).draw();
    });

    try {
      console.log("Trying to close the damn modal");
      $(waiting_results_raw_string).modal("hide");
    } catch (error) {
      console.log("Error:", error);
    }
  }
}

class PastFunctions {
  changeUseCase(user_input) {
    console.log("changeUseCase FUNCTION CALLED");
    var use_case = user_input.getAttribute("use_case");

    if (use_case == "sales") {
      document.getElementById("use_case_container").innerHTML = document.getElementById("use_case_sales_element").innerHTML;
      document.getElementById("user_case_navi_container").innerHTML = document.getElementById("use_case_navigator_element").innerHTML;
      $("#sales_use_case").toggleClass("usecase-selected");

      document.getElementById("use_case_container1").innerHTML = document.getElementById("use_case_sales_element_mobi").innerHTML;
      document.getElementById("user_case_navi_container1").innerHTML = document.getElementById("use_case_navigator_element_mobi").innerHTML;
      $("#sales_use_case_mobi").toggleClass("usecase_mobi-selected");
    } else if (use_case == "recruiting") {
      document.getElementById("use_case_container").innerHTML = document.getElementById("use_case_recruiting_element").innerHTML;
      document.getElementById("user_case_navi_container").innerHTML = document.getElementById("use_case_navigator_element").innerHTML;
      $("#recruiting_use_case").toggleClass("usecase-selected");

      document.getElementById("use_case_container1").innerHTML = document.getElementById("use_case_recruiting_element_mobi").innerHTML;
      document.getElementById("user_case_navi_container1").innerHTML = document.getElementById("use_case_navigator_element_mobi").innerHTML;
      $("#recruiting_use_case_mobi").toggleClass("usecase_mobi-selected");
    } else if (use_case == "consulting") {
      document.getElementById("use_case_container").innerHTML = document.getElementById("use_case_consulting_element").innerHTML;
      document.getElementById("user_case_navi_container").innerHTML = document.getElementById("use_case_navigator_element").innerHTML;
      $("#consulting_use_case").toggleClass("usecase-selected");

      document.getElementById("use_case_container1").innerHTML = document.getElementById("use_case_consulting_element_mobi").innerHTML;
      document.getElementById("user_case_navi_container1").innerHTML = document.getElementById("use_case_navigator_element_mobi").innerHTML;
      $("#consulting_use_case_mobi").toggleClass("usecase_mobi-selected");
    } else if (use_case == "security") {
      document.getElementById("use_case_container").innerHTML = document.getElementById("use_case_security_element").innerHTML;
      document.getElementById("user_case_navi_container").innerHTML = document.getElementById("use_case_navigator_element").innerHTML;
      $("#security_use_case").toggleClass("usecase-selected");

      document.getElementById("use_case_container1").innerHTML = document.getElementById("use_case_security_element_mobi").innerHTML;
      document.getElementById("user_case_navi_container1").innerHTML = document.getElementById("use_case_navigator_element_mobi").innerHTML;
      $("#security_use_case_mobi").toggleClass("usecase_mobi-selected");
    }
  }

  landingAnimation() {
    console.log("new PastFunctions().landingAnimation FUNCTION CALLED");
    if (parseInt(sessionStorage["landing_animation"]) < 4) {
      sessionStorage["landing_animation"] = parseInt(sessionStorage["landing_animation"]) + 1;
    } else {
      sessionStorage["landing_animation"] = 0;
    }

    var variants_2 = ["prospects", "customers", "competitor", "candidates", "targets"];
    $("#landing_top_animation").fadeOut(function () {
      $(this).text(variants_2[parseInt(sessionStorage["landing_animation"])]).fadeIn();
    });
    $("#landing_top_animation_mobi").fadeOut(function () {
      $(this).text(variants_2[parseInt(sessionStorage["landing_animation"])]).fadeIn();
    });
    setTimeout("new PastFunctions().landingAnimation()", 4000);
  }

  changeTestimonial() {
    console.log("changeTestimonial FUNCTION CALLED");

    if (parseInt(sessionStorage["testimonial"]) < 2) {
      sessionStorage["testimonial"] = parseInt(sessionStorage["testimonial"]) + 1;
    } else {
      sessionStorage["testimonial"] = 0;
    }
    var testimonials = [
      {
        name: "Aaron Lintz",
        logo: "/static/img/thoughtworks1.png",
        photo: "/static/img/lintz.jpg",
        title: "Sr. Talent Sourcing Specialist",
        quote: "Arxena is a unique tool that I've been waiting for someone to build. In minutes you get a birds-eye view of their team structure and location. This process would take a day to do manually.",
      },
      {
        name: "Craig Rajpal",
        logo: "/static/img/workato.png",
        photo: "/static/img/rajpal.jpg",
        title: "Enterprise Sales Director",
        quote:
          "Before Arxena, I had used everything from DiscoverOrg to LucidCharts and nothing worked, locating the right decision makers took hours… now it takes me minutes, Arxena has helped close over 300k in ARR, this is by far the best sales outreach tool I have used.",
      },
      {
        name: "John Calvani",
        logo: "/static/img/tritonexec2.png",
        photo: "/static/img/calvani.jpg",
        title: "Sr. Resourcing Associate",
        quote: "Arxena helps me map in minutes large F100 accounts saving me hours of manual work for resourcing projects.",
      },
    ];

    $("#testimonial_quote").fadeOut(function () {
      $(this).text(testimonials[parseInt(sessionStorage["testimonial"])]["quote"]).fadeIn();
    });
    $("#testimonial_photo").fadeOut(500, function () {
      $("#testimonial_photo").attr("src", testimonials[parseInt(sessionStorage["testimonial"])]["photo"]);
      $("#testimonial_photo").fadeIn(500);
    });
    $("#testimonial_logo").fadeOut(500, function () {
      $("#testimonial_logo").attr("src", testimonials[parseInt(sessionStorage["testimonial"])]["logo"]);
      $("#testimonial_logo").fadeIn(500);
    });
    $("#testimonial_title").fadeOut(function () {
      $(this).text(testimonials[parseInt(sessionStorage["testimonial"])]["title"]).fadeIn();
    });
    $("#testimonial_name").fadeOut(function () {
      $(this).text(testimonials[parseInt(sessionStorage["testimonial"])]["name"]).fadeIn();
    });

    $("#testimonial_quote1").fadeOut(function () {
      $(this).text(testimonials[parseInt(sessionStorage["testimonial"])]["quote"]).fadeIn();
    });
    $("#testimonial_photo1").fadeOut(500, function () {
      $("#testimonial_photo1").attr("src", testimonials[parseInt(sessionStorage["testimonial"])]["photo"]);
      $("#testimonial_photo1").fadeIn(500);
    });
    $("#testimonial_logo1").fadeOut(500, function () {
      $("#testimonial_logo1").attr("src", testimonials[parseInt(sessionStorage["testimonial"])]["logo"]);
      $("#testimonial_logo1").fadeIn(500);
    });
    $("#testimonial_title1").fadeOut(function () {
      $(this).text(testimonials[parseInt(sessionStorage["testimonial"])]["title"]).fadeIn();
    });
    $("#testimonial_name1").fadeOut(function () {
      $(this).text(testimonials[parseInt(sessionStorage["testimonial"])]["name"]).fadeIn();
    });
  }
}


export { LeftPanelTableActions, ListPageElements, PastFunctions };
if (typeof window !== 'undefined') {
  window.LeftPanelTableActions = LeftPanelTableActions;
  window.ListPageElements = ListPageElements;
  window.PastFunctions = PastFunctions;
}
